import { motion } from 'framer-motion'
import SectionWrapper from '../layout/SectionWrapper'

const events = [
  {
    date: '10 février 2025',
    title: 'Première Conversation',
    description: 'Le début de tout. Notre première discussion qui a changé nos vies à jamais.',
    emoji: '💬',
    highlight: 'Où tout a commencé'
  },
  {
    date: '21 février 2025',
    title: 'La Rencontre',
    description: 'Bibliothèque du CAM. Poulet Rouge. Notre première poutine ensemble.',
    emoji: '📚',
    highlight: 'Notre premier date'
  },
  {
    date: '28 février 2025',
    title: 'Avant la Distance',
    description: 'Ton voyage aux Bahamas. La distance qui a testé et renforcé notre connexion.',
    emoji: '✈️',
    highlight: "L'épreuve de la distance"
  }
]

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.3
    }
  }
}

const itemVariants = {
  hidden: { opacity: 0, x: -50 },
  visible: {
    opacity: 1,
    x: 0,
    transition: {
      duration: 0.8,
      ease: [0.25, 0.46, 0.45, 0.94]
    }
  }
}

export default function DebutsSection() {
  return (
    <SectionWrapper id="debuts" gradient="from-dark-primary via-dark-secondary to-dark-primary">
      {/* Section Header */}
      <motion.div className="text-center mb-16">
        <motion.span
          className="tag-pill mb-4"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <span>💫</span>
          <span>Les Débuts</span>
        </motion.span>

        <motion.h2
          className="text-4xl md:text-6xl font-serif font-bold gradient-text mb-4"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.2 }}
        >
          Où Tout a Commencé
        </motion.h2>

        <motion.p
          className="text-lg text-light-pink-100/70 max-w-xl mx-auto"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ delay: 0.4 }}
        >
          Février 2025 - Le mois qui a changé nos vies
        </motion.p>
      </motion.div>

      {/* Timeline */}
      <motion.div
        className="relative"
        variants={containerVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, margin: '-100px' }}
      >
        {/* Timeline Line */}
        <div className="absolute left-8 md:left-1/2 top-0 bottom-0 w-0.5 bg-gradient-to-b from-primary-pink via-accent-pink to-primary-pink transform md:-translate-x-1/2" />

        {events.map((event, index) => (
          <motion.div
            key={event.date}
            className={`relative flex items-center mb-12 ${
              index % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'
            }`}
            variants={itemVariants}
          >
            {/* Timeline Dot */}
            <motion.div
              className="absolute left-8 md:left-1/2 w-4 h-4 bg-primary-pink rounded-full transform -translate-x-1/2 z-10"
              whileInView={{
                scale: [1, 1.5, 1],
                boxShadow: [
                  '0 0 0 0 rgba(232, 81, 178, 0)',
                  '0 0 0 10px rgba(232, 81, 178, 0.3)',
                  '0 0 0 0 rgba(232, 81, 178, 0)'
                ]
              }}
              viewport={{ once: true }}
              transition={{ duration: 1.5, delay: 0.3 }}
            />

            {/* Content Card */}
            <motion.div
              className={`ml-20 md:ml-0 md:w-5/12 ${
                index % 2 === 0 ? 'md:pr-12' : 'md:pl-12'
              }`}
              whileHover={{ scale: 1.02 }}
              transition={{ duration: 0.3 }}
            >
              <div className="glass-card pink-glow">
                {/* Date Badge */}
                <div className="flex items-center gap-3 mb-4">
                  <span className="text-3xl">{event.emoji}</span>
                  <span className="text-sm text-primary-pink font-medium">
                    {event.date}
                  </span>
                </div>

                {/* Highlight Tag */}
                <span className="inline-block px-3 py-1 bg-primary-pink/20 text-primary-pink text-xs rounded-full mb-3">
                  {event.highlight}
                </span>

                <h3 className="text-2xl font-serif font-bold text-white mb-3">
                  {event.title}
                </h3>

                <p className="text-light-pink-100/70 leading-relaxed">
                  {event.description}
                </p>
              </div>
            </motion.div>
          </motion.div>
        ))}
      </motion.div>

      {/* Verse Quote */}
      <motion.blockquote
        className="text-center mt-16 max-w-2xl mx-auto"
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
      >
        <p className="text-xl md:text-2xl text-light-pink-100/80 italic font-serif leading-relaxed">
          "Dix février, première conversation
          <br />
          Mon coeur savait déjà, c'était pas une illusion"
        </p>
        <footer className="mt-4 text-primary-pink text-sm">
          — Verse 1
        </footer>
      </motion.blockquote>
    </SectionWrapper>
  )
}
